/* Bean Shipper · All Beans collection (sections/collection__bs-all-beans.liquid), 23 Sep 2026.
   Type tabs, taste and roast chips, sort, live counts, reveal on scroll and quick-add feedback.
   The filter state rides in the URL (?kind= &taste= &roast= &order=) so a filtered view can be shared.
   Adding to the bag is the theme's job: bean-shipper.js listens for [data-bs-quick-add] clicks.
   This file only mirrors the result on the button, read from the toast that script shows.
   Without this file every card still renders, links and adds. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bsab]');
  if (!root || root.getAttribute('data-bsab-ready')) return;
  root.setAttribute('data-bsab-ready', '1');

  function all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  var grid = root.querySelector('[data-bsab-grid]');
  var cells = grid ? all('[data-bsab-card]', grid) : [];
  var tabs = all('[data-bsab-type]');
  var flavorChips = all('[data-bsab-flavor]');
  var roastChips = all('[data-bsab-roast]');
  var clearBtns = all('[data-bsab-clear]');
  var chipClear = root.querySelector('.bsab__clear');
  var sortSels = all('[data-bsab-sort]');
  var countEl = root.querySelector('[data-bsab-count]');
  var emptyEl = root.querySelector('[data-bsab-empty]');
  var tools = root.querySelector('.bsab__tools');
  var bar = root.querySelector('[data-bsab-bar]');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var KINDS = { all: 1, single: 1, blend: 1, microlot: 1, guest: 1 };
  var FLAVORS = { smooth: 1, fruity: 1, bold: 1, dessert: 1 };
  var ROASTS = { light: 1, medium: 1, mediumdark: 1, dark: 1 };
  var SORTS = { featured: 1, low: 1, high: 1, az: 1 };
  var state = { kind: 'all', flavor: '', roast: '', sort: 'featured' };

  try {
    var q = new URLSearchParams(window.location.search);
    if (KINDS[q.get('kind')]) state.kind = q.get('kind');
    if (FLAVORS[q.get('taste')]) state.flavor = q.get('taste');
    if (ROASTS[q.get('roast')]) state.roast = q.get('roast');
    if (SORTS[q.get('order')]) state.sort = q.get('order');
  } catch (e) {}
  if (!root.querySelector('[data-bsab-type="' + state.kind + '"]')) state.kind = 'all';

  function kindOk(cell, kind) {
    if (kind === 'all') return true;
    if (kind === 'guest') return cell.getAttribute('data-guest') === '1';
    return cell.getAttribute('data-kind') === kind;
  }
  function flavorOk(cell) {
    return !state.flavor || (cell.getAttribute('data-flavors') || '').indexOf(' ' + state.flavor + ' ') !== -1;
  }
  function roastOk(cell) {
    return !state.roast || cell.getAttribute('data-roast') === state.roast;
  }
  function num(cell, attr) { return parseFloat(cell.getAttribute(attr)) || 0; }
  function byPos(a, b) { return num(a, 'data-pos') - num(b, 'data-pos'); }
  var sorters = {
    featured: byPos,
    low: function (a, b) { return (num(a, 'data-price') - num(b, 'data-price')) || byPos(a, b); },
    high: function (a, b) { return (num(b, 'data-price') - num(a, 'data-price')) || byPos(a, b); },
    az: function (a, b) { return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); }
  };

  var io = null;
  function columns() {
    if (!grid) return 1;
    var t = (window.getComputedStyle(grid).gridTemplateColumns || '').split(' ');
    var n = 0;
    for (var i = 0; i !== t.length; i++) { if (t[i] && t[i] !== '0px') n++; }
    return n || 1;
  }
  function reveal(visible) {
    if (reduce || !('IntersectionObserver' in window)) {
      visible.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }
    if (io) io.disconnect();
    var cols = columns();
    visible.forEach(function (c, i) {
      c.classList.remove('is-in');
      c.style.setProperty('--d', ((i % cols) * 80) + 'ms');
    });
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    visible.forEach(function (c) { io.observe(c); });
  }

  function writeUrl() {
    try {
      var u = new URL(window.location.href);
      var put = function (k, v, dflt) { if (v && v !== dflt) u.searchParams.set(k, v); else u.searchParams.delete(k); };
      put('kind', state.kind, 'all');
      put('taste', state.flavor, '');
      put('roast', state.roast, '');
      put('order', state.sort, 'featured');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function keepInView() {
    if (!tools || !bar) return;
    var barBottom = bar.getBoundingClientRect().bottom;
    var top = tools.getBoundingClientRect().top;
    if (top >= barBottom) return;
    var y = window.pageYOffset + top - barBottom - 12;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }

  function press(el, on) {
    el.classList.toggle('is-on', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function apply(initial) {
    var visible = [];
    cells.forEach(function (c) {
      var ok = kindOk(c, state.kind) && flavorOk(c) && roastOk(c);
      c.hidden = !ok;
      if (ok) visible.push(c);
    });
    var order = sorters[state.sort] || byPos;
    if (grid) {
      var frag = document.createDocumentFragment();
      cells.slice().sort(order).forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
      grid.hidden = visible.length === 0;
    }
    visible.sort(order);

    tabs.forEach(function (tab) {
      var k = tab.getAttribute('data-bsab-type');
      var n = 0;
      cells.forEach(function (c) { if (kindOk(c, k) && flavorOk(c) && roastOk(c)) n++; });
      var el = tab.querySelector('[data-bsab-n]');
      if (el) el.textContent = String(n);
      press(tab, k === state.kind);
    });
    flavorChips.forEach(function (c) { press(c, c.getAttribute('data-bsab-flavor') === state.flavor); });
    roastChips.forEach(function (c) { press(c, c.getAttribute('data-bsab-roast') === state.roast); });

    if (chipClear) chipClear.hidden = !(state.kind !== 'all' || state.flavor || state.roast);
    if (countEl) countEl.textContent = visible.length + (visible.length === 1 ? ' coffee' : ' coffees');
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    sortSels.forEach(function (sel) { if (sel.value !== state.sort) sel.value = state.sort; });

    reveal(visible);
    if (!initial) { writeUrl(); keepInView(); }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { state.kind = tab.getAttribute('data-bsab-type'); apply(false); });
  });
  flavorChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-bsab-flavor');
      state.flavor = state.flavor === f ? '' : f;
      apply(false);
    });
  });
  roastChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var r = chip.getAttribute('data-bsab-roast');
      state.roast = state.roast === r ? '' : r;
      apply(false);
    });
  });
  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.kind = 'all'; state.flavor = ''; state.roast = ''; apply(false); });
  });
  sortSels.forEach(function (sel) {
    sel.addEventListener('change', function () { state.sort = SORTS[sel.value] ? sel.value : 'featured'; apply(false); });
  });

  /* The theme header is position:fixed. Park the filter bar right under whatever part of it is on
     screen, so it never tucks behind the header or floats below a header that has moved away. */
  var header = document.querySelector('header.nav') || document.querySelector('[data-bs-header]');
  var lastTop = -1;
  var ticking = false;
  function syncTop() {
    ticking = false;
    if (!header) return;
    var b = Math.round(header.getBoundingClientRect().bottom);
    if (b > 0 && b <= 200) { if (b !== lastTop) { lastTop = b; root.style.setProperty('--top', b + 'px'); } }
    else if (lastTop !== 0) { lastTop = 0; root.style.setProperty('--top', '0px'); }
  }
  function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(syncTop); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  syncTop();

  /* Quick-add feedback: bean-shipper.js posts to /cart/add.js, opens the drawer and shows a
     .bs-toast; its is-error class marks a failed add. */
  function setLabel(btn, longText, shortText) {
    var l = btn.querySelector('[data-bsab-qa-l]');
    var s = btn.querySelector('.bsab-card__qa-s');
    if (l) l.textContent = longText;
    if (s) s.textContent = shortText;
  }
  function watchToast(done) {
    if (!('MutationObserver' in window)) { done(null); return; }
    var finished = false;
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (finished || !n.classList || !n.classList.contains('bs-toast')) return;
          finished = true;
          mo.disconnect();
          done(!n.classList.contains('is-error'));
        });
      });
    });
    mo.observe(document.body, { childList: true });
    window.setTimeout(function () { if (!finished) { finished = true; mo.disconnect(); done(null); } }, 6000);
  }
  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bsab-qa]') : null;
    if (!btn || btn.classList.contains('is-busy')) return;
    if (!btn._bsabText) {
      var l = btn.querySelector('[data-bsab-qa-l]');
      var s = btn.querySelector('.bsab-card__qa-s');
      btn._bsabText = [l ? l.textContent : '', s ? s.textContent : ''];
    }
    var orig = btn._bsabText;
    btn.classList.remove('is-added');
    btn.classList.add('is-busy');
    setLabel(btn, 'Adding…', 'Adding…');
    watchToast(function (ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-added');
        setLabel(btn, 'Added to bag', 'Added');
        window.setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, orig[0], orig[1]); }, 1600);
      } else {
        setLabel(btn, orig[0], orig[1]);
      }
    });
  });

  root.classList.add('bsab--js');
  apply(true);
  window.setTimeout(function () {
    var vh = window.innerHeight;
    cells.forEach(function (c) {
      if (c.hidden || c.classList.contains('is-in')) return;
      var r = c.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) c.classList.add('is-in');
    });
  }, 1500);
})();
